import React, { useState, useEffect, useRef } from 'react';

const TableOfContents = ({ markdownContent }) => {
  const [headings, setHeadings] = useState([]);
  const [showMoreIndicator, setShowMoreIndicator] = useState(false);
  const tocRef = useRef(null);

  useEffect(() => {
    if (!markdownContent) return;

    // Extract headings from markdown content
    const lines = markdownContent.split('\n');
    const extractedHeadings = [];

    lines.forEach((line, index) => {
      const trimmedLine = line.trim();
      if (trimmedLine.startsWith('#')) {
        const level = trimmedLine.match(/^#+/)[0].length;
        const text = trimmedLine.replace(/^#+\s*/, '');
        
        if (level >= 1 && level <= 3 && text) { // Only H1, H2, H3
          const id = text
            .toLowerCase()
            .replace(/[^a-z0-9\s]/g, '')
            .replace(/\s+/g, '-')
            .trim();
          
          extractedHeadings.push({
            id,
            text,
            level,
            lineIndex: index
          });
        }
      }
    });

    setHeadings(extractedHeadings);
  }, [markdownContent]);

  const scrollToHeading = (headingId) => {
    const element = document.getElementById(headingId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  if (headings.length === 0) return null;

  return (
    <div className="table-of-contents">
      <div className="toc-title">Contents</div>
      <ul className="toc-list">
        {headings.map((heading, index) => (
          <li 
            key={index}
            className={`toc-item toc-level-${heading.level}`}
            onClick={() => scrollToHeading(heading.id)}
          >
            {heading.text}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TableOfContents;